import { render, staticRenderFns } from "./ReplyNewParentingTime.vue?vue&type=template&id=4d70dba2"
import script from "./ReplyNewParentingTime.vue?vue&type=script&lang=ts"
export * from "./ReplyNewParentingTime.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports